var advert_box = ( function ( $ ) {
    
    var cookie_key = 'advert_box_country_code';

    var _init = function () {
        console.log( 'init advert box code' );

        var $advert_boxes = $( '.advert-box-placeholder' );

        if ( $advert_boxes.length ) {
            _get_user_country_code().then(function ( country_code ) {
                console.log( 'country_code', country_code )
                
                $advert_boxes.each( function () {
                    var $advert_box      = $( this );
                    var secondary        = $advert_box.data( 'secondary' ) ? 1 : 0;
                    var therapeutic_area = $advert_box.data( 'ta' );
                    var page             = $advert_box.data( 'page' );

                    var data = {
                        action: 'crate_get_advert_box_content',
                        nonce: ScriptData.crate_get_advert_box_content_nonce,
                        therapeutic_area: therapeutic_area,
                        page: page,
                        secondary: secondary,
                        country_code: country_code,
                    };

                    $.get( ScriptData.ajaxurl, data, function ( response ) {
                        console.log( 'response', response );

                        if ( response.success && response.html ) {
                            $advert_box.replaceWith( response.html );
                        }
                    } );
                } );
            });
        }
    };
    
    var _get_user_country_code = async function () {
        var country_code = $.cookie( cookie_key );

        if ( country_code && typeof country_code === 'string' ) {
            return country_code;
        }

        try {
            const ip_data = await $.getJSON( 'https://ipapi.co/json/' );
            const country_code = ip_data && ip_data.country_code ? ip_data.country_code : null;

            if ( country_code && typeof country_code === 'string' ) {
                $.cookie( cookie_key, country_code, { expires: new Date( Date.now() + 30 * 60 * 1000 ), path: '/' } );

                return country_code;
            } else {
                throw new Error( 'country_code code not found in response' );
            }
        } catch (error) {
            console.log( 'IP API request failed: ' + error );
            
            return null;
        }
    }

    $( document ).ready( _init );

    return {};

} )( jQuery );

module.exports = advert_box;